export default __webpack_public_path__ + "static/media/Stand alone main cover.ee8cd35e.jpg";